import { useState, useEffect } from "react";
import * as S from "./styelsLayout";
import { Footer } from "../Components/Layout/footer";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from 'react-router-dom';
import { NotificationMessage } from "../Components/Manager/NotificationMessage";
import { useToken } from "../Components/TokenContext";
import { Header } from "../Components/Layout/header";
function ParticipanteLayout({ children }) {
    const navigate = useNavigate();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;
    const [notification, setNotification] = useState(null);
    const [showNavbar, setShowNavbar] = useState(false);

    const handleShowNavbar = () => {
      setShowNavbar(!showNavbar);
    };
  
    const location = useLocation();

    const { tokenData } = useToken();
    
    async function handleLogout (){

        try {
            const response = await fetch(`${baseUrl}/participante/logout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
            });
    
            const result = await response.json();
    
            if (!response.ok) {
                setNotification({
                    type: 'error',
                    message: 'Não é possível fazer logoff do usuário.',
                    show: true,
                });
                return;
            }
       
            localStorage.removeItem('user_id');
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_type');
            navigate('/participantes/login');

            setNotification({
                type: 'success',
                message: result.message,
                show: true,
            });

        } catch (error) {
            console.error(error.message);
        }
       
    }

    useEffect(() => {
        if (location.state?.message) {
            setNotification(location.state.message);

            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    return (
        <S.Container>
            <Header isLogged={true} />
            {children}
            {notification && (
                <NotificationMessage
                    type={notification.type}
                    message={notification.text}
                    show={true}
                    onClose={() => setNotification(null)}
                />
            )}
            <Footer/>
        </S.Container>
    );
}

export default ParticipanteLayout;